import React, { useState } from 'react'
import './Card.css'
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { OverlayContainer } from './CardStylings';

let OverlayHeight = "auto";

function format_cur(value, fmtcur="USD"){
    var fmtloc = 'de-DE';
    if (fmtcur == "USD"){
        fmtloc = 'en-US';
    }
    return value.toLocaleString(fmtloc, { style: 'currency', currency: fmtcur });
}

const ROBODK_WEB_OPEN = "/robodk-web/?--OEM&--LibraryPath=/library/&-OpenURL="


export const Card = (props: any) => {
    const [OverlayDisplay, setOverlayDisplay] = useState("none");

    return (
        <div 
            id={props.data["name"].split(" ").join("-")} 
            className='card-container'
        >
            <div 
                className='card-info'
                onMouseEnter={(e: React.MouseEvent) => {
                    if (OverlayDisplay == "none") {
                        let robot_title = e.currentTarget.childNodes[0] as HTMLHeadingElement;
                        let robot_image = e.currentTarget.childNodes[1] as HTMLDivElement;
                        let image_padding = 17;

                        OverlayHeight = (robot_title.clientHeight + robot_image.clientHeight + image_padding).toString();

                        setOverlayDisplay("flex");
                    }
                }}
                onMouseLeave={(e: React.MouseEvent) => setOverlayDisplay("none")}
            >
                <h6 className='card-title'>{props.data["name"]}</h6>
                <div className="image-box">
                    <LazyLoadImage 
                        className="img-item" 
                        // src={"lib_assets/np-icon.png"} 
                        src={props.data["image"]}
                        alt={props.data["name"]}
                        onError={(e) => {
                            e.target.src = "lib_assets/np-icon-1.png";
                        }}
                        threshold={100}
                    />
                </div>

                <table className='table table-striped'>
                    <tbody>
                        {Object.keys(props.data["specs"]).map((key) => {
                            if (props.data["specs"][key]["display"] != "no") {

                                if (key == "price"){
                                    var cur = props.data["specs"][key]["currency"] || "USD";
                                    var text_val = format_cur(props.data["specs"][key]["value"], cur);

                                return (
                                    <tr key={"spec-" + props.data["specs"][key]["key"]}>
                                        <td>{props.data["specs"][key]["key"]}</td>
                                        {Array.isArray(props.data["specs"][key]["value"]) && (
                                            <td>{props.data["specs"][key]["value"].join(", ")}</td>
                                        )}
                                        {!Array.isArray(props.data["specs"][key]["value"]) && (
                                            <td>{text_val}</td>
                                        )}
                                    </tr>
                                    )
                                } else {
                                return (
                                    <tr key={"spec-" + props.data["specs"][key]["key"]}>
                                        <td>{props.data["specs"][key]["key"]}</td>
                                        {Array.isArray(props.data["specs"][key]["value"]) && (
                                            <td>{props.data["specs"][key]["value"].join(", ")}</td>
                                        )}
                                        {!Array.isArray(props.data["specs"][key]["value"]) && (
                                            <td>{props.data["specs"][key]["value"]}</td>
                                        )}
                                    </tr>
                                )
                                }
                            }
                        })}
                    </tbody>
                </table>
            </div>

            <OverlayContainer
                key={"overlay-" + props.data["name"]}
                height={OverlayHeight}
                display={OverlayDisplay}
            >
                <div className='item-links'>
                    {(props.data["3d-view"]["allowed"] != "no" && (
                        <a
                            href={ROBODK_WEB_OPEN + props.data["3d-view"]["path"]}
                            // href={window.Paths.ROBODK_WEB_OPEN + "/library-stations/lib/" + p.file}
                            target={"_blank"}
                            type={"button"}
                            role={"button"}
                            className={"btn-item-link center-block"}
                        >
                            <strong>3D View</strong>
                        </a>
                    ))}

                    {(props.data["download"]["allowed"] != "no") && (
                        <a
                            href={props.data["download"]["path"]}
                            // onClick={(e) => window.get_lib(false, p.file, "station")}
                            role={"button"}
                            className={"btn-item-link center-block"}
                        >
                            <strong>Download</strong>
                        </a>
                    )}
                </div>
            </OverlayContainer>
        </div>
    )
};
